import React from "react"

import {
  Container,
  PreTitle,
  Title,
  DescriptionRow,
  Description,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  DesktopWrapper,
  NextCourses,
  Courses,
  CourseWrapper,
  CourseTitle,
  CourseSubtitle,
  CourseList,
  CourseListItem,
  CourseListItemIcon,
  CourseListItemTitle,
  CourseListItemText,
  CourseLink,
  MobileWrapper,
  ScrollLabelWithArrow,
  ScrollContainer,
  ScrollableGrid,
  ExploreAllLink,
} from "./styles"

const processSubtitle = (subtitle) => {
  const parts = subtitle.split("*")
  return parts.map((part, index) => (index % 2 === 1 ? <em key={part}>{part}</em> : part))
}

const HomePageInstitute = () => {
  const courses = [
    {
      title: "Health Coach Certification",
      subtitle: "National Board Certified *health & wellness coach*",
      items: [
        {
          title: "Session type",
          text: "Live, interactive online classes twice weekly",
        },
        {
          title: "Length",
          text: "20 week cohort",
        },
        {
          title: "Certification",
          text: "NBHWC (Graduates eligible for HWC certifying exam)",
        },
        {
          title: "Additional info",
          text: "Also includes Function Nutrition Training",
        },
      ],
      link: "https://institute.mindbodygreen.com/health-coach-certification",
    },

    {
      title: "Life Coaching",
      subtitle: "mindbodygreen *life coach*",
      items: [
        {
          title: "Session type",
          text: "2 live sessions weekly + on-demand lessons",
        },
        {
          title: "Length",
          text: "12 week cohort",
        },
        {
          title: "Certification",
          text: "mindbodygreen Life Coach certification",
        },
        {
          title: "Additional info",
          text: "Complementary Introductory Business Course ($1,197 value)",
        },
      ],
      link: "https://institute.mindbodygreen.com/life-coaching",
    },
    {
      title: "Functional Nutrition Training",
      subtitle: "mindbodygreen *functional nutrition expert*",
      items: [
        {
          title: "Session type",
          text: "On demand, watch any time <br/> <br/>",
        },
        {
          title: "Length",
          text: "30+ hours",
        },
        {
          title: "Certification",
          text: "NSAM/AFAA continuing education credits",
        },
        {
          title: "Additional info",
          text: "660+ pages of in-depth study guides",
        },
      ],
      link: "https://institute.mindbodygreen.com/functional-nutrition-training",
    },
  ]

  return (
    <Container>
      <PreTitle>Institute</PreTitle>
      <Title>Transform your career and change your life</Title>
      <DescriptionRow>
        <Description>
          Comprehensive online training programs designed to transform your career or deepen your
          personal understanding of health, wellness, and nutrition.
        </Description>
        <List>
          <ListItem>
            <ListItemIcon id="certification" width={21} height={20} />
            <ListItemText>Industry recognized programs and accreditations</ListItemText>
          </ListItem>
          <ListItem>
            <ListItemIcon id="collaboration" width={21} height={20} />
            <ListItemText>Collaborate with the world’s top wellness professionals</ListItemText>
          </ListItem>
          <ListItem>
            <ListItemIcon id="group-of-three" width={21} height={20} />
            <ListItemText>Life long alumni community and networking</ListItemText>
          </ListItem>
        </List>
      </DescriptionRow>
      <DesktopWrapper>
        <NextCourses>Next courses</NextCourses>
        <Courses>
          {courses.map((course) => (
            <Course key={course.title} course={course} />
          ))}
        </Courses>
      </DesktopWrapper>
      <MobileWrapper>
        <ScrollLabelWithArrow />
        <ScrollContainer>
          <ScrollableGrid>
            {courses.map((course) => (
              <Course key={course.title} course={course} />
            ))}
          </ScrollableGrid>
        </ScrollContainer>
      </MobileWrapper>
      <ExploreAllLink
        href="https://institute.mindbodygreen.com/"
        title="Explore all courses"
        aria-label="Explore all courses"
      >
        Explore all courses
      </ExploreAllLink>
    </Container>
  )
}

const Course = ({ course }) => (
  <CourseWrapper>
    <CourseTitle>{course.title} →</CourseTitle>
    <CourseSubtitle>{processSubtitle(course.subtitle)} </CourseSubtitle>
    <CourseList>
      {course.items.map((item) => (
        <CourseListItem key={item.title}>
          <div>
            <CourseListItemIcon id="sustainable" width={24} height={24} />
          </div>
          <div>
            <CourseListItemTitle>{item.title}</CourseListItemTitle>
            <CourseListItemText dangerouslySetInnerHTML={{ __html: item.text }} />
          </div>
        </CourseListItem>
      ))}
    </CourseList>
    <CourseLink
      href={course.link}
      title={`View ${course.title}`}
      aria-label={`View ${course.title}`}
    >
      View program
    </CourseLink>
  </CourseWrapper>
)

export default HomePageInstitute
